module.exports = __webpack_public_path__ + "img/cbr1.86f814ce.gif";